export default {
  router: [
    {
      exact: true,
      path: '/CarrierManagement/FreightBillCheck',
      title: '运费账单核对',
    },
  ],
  title: '运费账单核对',
};
